import React from "react";

const Speaker = () => (
    <div className="row speaker">
	<div className="three columns header-col">
	    <h1>
		<span>Speaking</span>
	    </h1>
	</div>
	
	<div className="nine columns main-col">
	    <div className="row item">
	        <div className="twelve columns">
	          <h4 className="mb0">
	            Next Gen Summit
	          </h4>
	          <p className="info">
	            Panel Speaker
	            <span>&bull;</span>
	            2018
	          </p>
	          <p>
	            Diversity in Entrepreneurship
	          </p>
	        </div>
	    </div>
	    <div className="row item">
	        <div className="twelve columns">
	          <h4 className="mb0">
	            NYC Food Policy Center
	          </h4>
	          <p className="info">
	            Panel Speaker
	            <span>&bull;</span>
	            2018
	          </p>
	          <p>
	            Emerging Tech in Food
	          </p>
	        </div>
	    </div>
	    <div className="row item">
	        <div className="twelve columns">
	          <h4 className="mb0">
	            SXSW EDU
	          </h4>
	          <p className="info">
	            Workshop
	            <span>&bull;</span>
	            2018
	          </p>
	          <p>
	            Improvised Assistive Tech $5 Mystery Box Challenge
	          </p>
	        </div>
	    </div>
	    <div className="row item">
	        <div className="twelve columns">
	          <h4 className="mb0">
	            Universities Fighting World Hunger International Summit
	          </h4>
	          <p className="info">
	            Breakout Session
	            <span>&bull;</span>
	            2018
	          </p>
	          <p>
	            Cross Disciplinary Co-Creation: How NYU engages multiple majors to solve hunger
	          </p>
	        </div>
	    </div>
	    <div className="row item">
	        <div className="twelve columns">
	          <h4 className="mb0">
	            Maine Hunger Dialogue
	          </h4>
	          <p className="info">
	            Breakout Session
	            <span>&bull;</span>
	            2017
	          </p>
	          <p>
	            Solving Food Waste in Real Time
	          </p>
	        </div>
	    </div>
	    <div className="row item">
	        <div className="twelve columns">
	          <h4 className="mb0">
	            University of Missouri
	          </h4>
	          <p className="info">
	            TEDx Talk
	            <span>&bull;</span>
	            2016
	          </p>
	          <p>
	            How Hunger Gave us Purpose
	          </p>
	        </div>
	    </div>
	    <div className="row item">
	        <div className="twelve columns">
	          <h4 className="mb0">
	            New York Times
	          </h4>
	          <p className="info">
	            Feature
	            <span>&bull;</span>
	            2016
	          </p>
	          <p>
	            Leftover Meal Plan Swipes: No Waste Here
	          </p>
	        </div>
	    </div>
        </div>
    </div>
);

export default Speaker;



// WEBPACK FOOTER //
// ./src/components/resume/Speaker.jsx